import React, { Component } from "react";
import BackgroundSlider from 'react-background-slider'

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Devsolucoes from "../../components/dev-solucoes";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";

import image1 from '../../assets/img/solucoes/img-solucoes_rastreabilidade-0.jpg'
import image2 from '../../assets/img/solucoes/img-solucoes_rastreabilidade-01.jpg'
import image3 from '../../assets/img/solucoes/img-solucoes_rastreabilidade-02.jpg'


class Ativos extends Component {
  
    render() {
      return (
          <React.Fragment>
                <Headbody></Headbody>
                <Menu></Menu>
                <section class="header-interno padrao">
                  <div class="container">
                    <div class="row">
                      <div class="col-12 col-lg-8">
                        <h2>Itech<span class="azul">Flow</span></h2>
                        <h3>Solução para Rastreamento de Equipamentos</h3>
                        <span class="saude">Saúde</span>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="conteudo-interno">
                  <div class="container">
                    <div class="row d-lg-flex align-items-lg-center">
                      <div class="col-12 col-lg-6">
                        {/* <div id="galeria" class="owl-carousel">
                          <img src={"../assets/img/solucoes/img-solucoes_rastreabilidade-0.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          <img src={"../assets/img/solucoes/img-solucoes_rastreabilidade-01.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          <img src={"../assets/img/solucoes/img-solucoes_rastreabilidade-02.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          </div> */}
                          <div style={{width: '480px', height: '400px'}} class="img-fluid m-auto" >
                              <BackgroundSlider
                                  images={[image1, image2, image3]}
                                  duration={5}
                                  transition={0.5}
                              />
                              {/* <img src={image1} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img> */}
                          </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <h3>Descrição:</h3>
                        {/* <p>O Módulo de Ativos foi desenvolvido com o objetivo de disponibilizar a rastreabilidade de equipamentos em tempo real, facilitando o processo de ronda e calibração de ativos. Nossa solução possibilita a localização e trajetória assertiva de cada equipamento, graças à tecnologia IOT.</p> */}
                          <p>O Módulo de Ativos foi desenvolvido com o objetivo de disponibilizar a rastreabilidade de equipamentos em tempo real, facilitando o processo de ronda e calibração de ativos. Nossa solução possui tecnologia BLE (Tecnologia Bluetooth de baixa energia) e Machine Learning (AI), possibilitando a localização e trajetória assertiva dos ativos monitorados.</p>
                        <iframe width="100%" height="300" src="https://www.youtube.com/embed/6ghqnQ2x_uM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 mt-5">
                        <h3>Aplicação:</h3>
                        <p>Hospitais, clínicas diagnósticas, e outras industrias</p> 
                        
                        <h3>Principais funcionalidades e benefícios:</h3>
                      </div>


                      <div class="col-12 col-md-6">
                        <ul>
                          <li>Localize o seu ativo em tempo real</li>
                          <li>Integração e sincronismo com os principais ERPs</li>
                          <li>Controle através de Dash-board com informações detalhadas de cada equipamento</li>
                          <li>Alertas para equipamentos que necessitam de calibração;</li>
                          <li>Envia alertas para fornecedor externo calibrar equipamentos.</li>
                          <li>Geração automática de relatórios;</li>
                          <li>Armazenamento de informações em nuvem sem limite de usuários</li>
                          <li>SW desenvolvido Web-based (Não requer APP)</li>
                          <li>Todas visualizações são possiveis em Pcs, tablet e smartphone</li>
                        </ul>
                      </div>

                      <div class="col-12 col-md-6">
                        <ul>
                          <li>Alertas de movimentação de equipamentos;</li>
                          <li>Alertas via Telegram, Whats app, email, SMS, etc..;</li>
                          <li>Elimina processo de localização física dos ativos</li>
                          <li>Maior agilidade no processo de Ronda e Calibração dos equipamentos</li>
                          <li>Alertas de transferência de ativos para área não permitida</li>
                          <li>Delimitação de área de uso.</li>
                          <li>Permite histórico de movimentação de equipamentos.</li>
                          <li>Previne uso de equipamentos em área de risco (COVID)</li>
                        </ul>

                        <br></br><br></br>
                      </div>
                      <div class="col-12 text-center" >
                          <a href={"../pdf/catalogo-ativos.pdf"} class="btn-itm" target="_blank">Baixar Catálogo</a>
                          <br></br><br></br>
                      </div>
                    </div>
                  </div>
                </section>

            
                <Devsolucoes></Devsolucoes>
                <Footer></Footer>
                <Endbody></Endbody>
          </React.Fragment>
        
      );
    }
  }

export default Ativos;